import { render } from "./NerpathamBundleList.vue?vue&type=template&id=0f2b077a&scoped=true"
import script from "./NerpathamBundleList.vue?vue&type=script&lang=js"
export * from "./NerpathamBundleList.vue?vue&type=script&lang=js"

import "./NerpathamBundleList.vue?vue&type=style&index=0&id=0f2b077a&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2b077a"]])

export default __exports__